import { createRoot } from 'react-dom/client';
import { App } from './App';

Office.onReady(() => {
  const container = document.getElementById('root')!;
  createRoot(container).render(<App />);
});
